window.addEventListener('DOMContentLoaded', () => {
    new Swiper('.swiper.our-stores__container', {
        slidesPerView: 1.3,
        spaceBetween: 4,
        // Responsive breakpoints
        breakpoints: {
            950: {
                slidesPerView: 2.5,
                spaceBetween: 6
            },
            1280: {
                slidesPerView: 3.5,
            }
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        keyboard: {
            enabled: true,
        }
    });
});
